import { createTheme } from '@mui/material/styles';

/**
 * The MUI theme — the single source of truth for the dashboard's look. Mirrors
 * the legacy `--p-*` CSS tokens in styles.css (background #050608, brand blue
 * #1976d2, accent teal #03dac6, the muted-white text ramp) so MUI surfaces and
 * any not-yet-migrated CSS read as one design. Dark-only by design: this is
 * operator chrome, not customer-themable launcher UI.
 */
export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#1976d2', dark: '#1565c0', contrastText: '#ffffff' },
    secondary: { main: '#03dac6', contrastText: '#06201d' },
    error: { main: '#ff8a80' },
    success: { main: '#66bb6a' },
    background: {
      default: '#050608', // --p-bg-page
      paper: '#0b0c0f', // --p-surface-1
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(232, 234, 237, 0.72)', // --p-text-3
    },
    divider: 'rgba(255, 255, 255, 0.10)', // --p-border-2
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    // Flat, bordered surfaces to match the existing card chrome (no heavy MUI
    // elevation gradients on a near-black page).
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none', border: '1px solid rgba(255, 255, 255, 0.10)' },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0, color: 'transparent' },
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(11, 11, 13, 0.85)',
          backdropFilter: 'blur(8px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
        },
      },
    },
    MuiButton: { defaultProps: { disableElevation: true } },
  },
});
